import { API_TAGS } from '@/shared/api/api-tags';

type BulkMessageInvalidationTag = {
  type: typeof API_TAGS.BulkMessages;
  id: string;
};

export function buildBulkMessageInvalidationTags(
  bulkMessageCode: string,
  branchCode?: string,
): BulkMessageInvalidationTag[] {
  const tags: BulkMessageInvalidationTag[] = [
    { type: API_TAGS.BulkMessages, id: bulkMessageCode },
  ];

  if (branchCode) {
    tags.push({ type: API_TAGS.BulkMessages, id: branchCode });
  }

  return tags;
}
